export interface PoolNumberItem {
  id?: number,
  msisdn: string,
}

export interface PoolsState {
  pools: PoolItem[],
  poolItem?: PoolItem,
  poolNumbers?: PoolNumberItem[],
  poolNumberItem?: PoolNumberItem,
}

export class PoolFilter {
  name?:string;
  description?:string;
  originators?:string;
  originators_count?:number;
  page_number: number = 1;
}

export interface PoolItem {
  id?:number,
  name: string,
  description?:string,
  originators?: string|string[],
  originators_count?:number,
}

export class PoolItemImpl implements PoolItem{
  name: string;
  originators: string | string[];

  constructor() {
    this.name = '';
    this.originators = [];
  }
}

export interface PoolNumbersFilterShape {
  msisdn?: string,
  page_number?: number
}